/**
 * Map từ RefType sang tên layout detail ở màn hình danh sách
 * Mục đích tạo file này là do 1 layout Detail có thể chứa 2 reftype
 * NTLOC 05.06.2023
 */
export default {
  BUTransferDetailCustom: 56, // Chuyển khoản kho bạc vào TK tiền gửi
  BUTransferDepositDetailCustom: 561, // Chuyển khoản kho bạc vào TK tiền gửi
  BuPlanWithDrawDepositDetailCustom: 562, // Rút dự toán tiền gửi
  BUPlanwithdrawCashDetailCustom: 54, // Rút dự toán tiền mặt
  BUPlanWithdrawTransferDetailCustom: 55, // Rút dự toán chuyển khoản
  BUPlanWithdrawSalaryTransferDetailCustom: 563, // Rút dự toán chuyển khoản lương, bảo hiểm
  BUPlanReceiptDetailCustom: [51, 52], //Nhận dự toán đầu nămNOTE: 51 52 dùng chung form Detail đặt tên giống nhau
  // Phiếu thu rút dự toán nhập quỹ
  105: {
    ApproveVoucherCAReceiptPlanWithdrawList: 'CAReceiptPlanWithdrawDetailCustom',
    ApproveVoucherCAReceiptList: 'CAReceiptPlanWithdrawSecondDetailCustom',
  },
  CAReceiptDetailCustom: 101, // Phiếu thu rút dự toán nhập quỹ
  CAReceiptSaleDetailCustom: [102, 154], // Phiếu thu bán hàng, thu tiền gửi bán hàng
  CAReceiptWithdrawDetailCustom: 114, //Phiếu thu rút tiền gửi ngân hàng, kho bạc
  BUPlanCancelDetailCustom: 69, // Hủy dự toán,
  BUVoucherListPlannedDetailCustom: 63, // Bảng kê chứng từ thanh toán đã cấp dự toán
  BUVoucherListNotPlannedDetailCustom: 64, // Bảng kê chứng từ thanh toán chưa cấp dự toán
  BUVoucherListReceipExpenseDetail: 65, // Bảng kê chứng từ thanh toán ghi thu - ghi chi
  BUVoucherListOtherDetail: 66, // Bảng kê chứng từ khác
  BUVoucherListRealExpenseDetail: 70, // Bảng kê chứng từ thanh toán thực chi
  BUPlanAdjustmentDetailCustom: 53, //Điều chỉnh dự toán
  SUTransferDetailCustom: 207, // Điều chuyển CCDC
  SUIncrementDetailCustom: 205, // Ghi tăng CCDC
  SUDecrementDetailCustom: 206, // Ghi giảm CCDC
  BUExpenseWithdrawAdjustmentDetailCustom: 652, // Điều chỉnh kinh phí
  BURealExpenseAdjustmentDetailCustom: 654, // Điều chỉnh thực chi
  PUInvoiceDetailCustom: 301, // Mua hàng chưa thanh toán (Hóa đơn mua hàng)
  INTransferDetailCustom: 203, // Chuyển kho
  INAdjustmentDetailCustom: 204, // Điều chỉnh tồn kho
  INOutwardDetailCustom: 202, // Xuất kho
  INInwardDetailCustom: 201, // Nhập kho
  BADepositDetailCustom: 153, // Thu tiền gửi
  SAInvoiceDetailCustom: 351, //Bán hàng chưa thu tiền
  BABankTransferDetailCustom: 162, // Chuyển tiền nội bộ
  CAPaymentDetailCustom: 106, //Phiếu chi thông thường
  CAPaymentDepositDetailDetailCustom: 113, // Phiếu chi nộp vào ngân hàng, kho bạc
  CAFundInventoryDetailCustom: 115, // Kiểm kê quỹ
  BAWithDrawDetailCustom: 157, // Chi tiền gửi
  BUBudgetReserveDetailCustom: 73, //Dự toán giữ lại
  GLVoucherDetailHTCustom: 401, // Chứng từ nghiệp vụ khác
  GLEndYearTransferDetailCustom: 402, //Kết chuyển số dư cuối năm
  GLBeginningYearTransferDetailCustom: 403, //Quyết toán số dư đầu năm
  CAReceiptCustomerDetailCustom: 104, //Phiếu thu tiền khách hàng
  //Phiếu thu tiền khách hàng
  BADepositCustomerDetailCustom: 156,
  GLProfitLossTransferDetailCustom: 404, //Xác định kết quả hoạt động
  GLProvisionalTaxInComeEnterpriseDetailCustom: 420, //Tạm tính thuế thu nhập doanh nghiệp
  GLFinalTaxInComeEnterpriseDetailCustom: 421, //Quyết toán thuế thu nhập doanh nghiệp
  GLVoucherSummaryTableDetailCustom: 406, //Bảng tổng hợp chứng từ cùng loại
  SAReturnDetailsCustom: 352, //Hàng bán trả lại
  BUCommitmentRequestDetailCustom: 71, // Đề nghị cam kết chi
  BUCommitmentAdjustmentDetailCustom: 72, // Điều chỉnh cam kết chi
  BUOpeningCommitmentDetailCustom: 606, // Nhập CKC ban đầu
  GLPostedVoucherDetailCustom: 407, // Chứng từ ghi sổ
  BATransferDepositDetailCustom: 151, //Tiền đang chuyển đến
  BATransferWithdrawDetailCustom: 152, //Tiền đang chuyển đi
  FAVoucherDepreciationDetailCustom: 413, // Lấy hao mòn tự nhiên TSCĐ từ QLTS.VN
  FAVoucherIncreamentDetailCustom: 410, // Ghi tăng TSCĐ từ QLTS.VN
  FAVoucherAdjustmentDetailCustom: 411, // Đánh giá lại TSCĐ từ QLTS.VN
  FAVoucherDepreciateDetailCustom: 412, // Lấy khấu hao TSCĐ từ QLTS.VN
  FAVoucherDecrementDetailCustom: 414, // Ghi giảm TSCĐ từ QLTS.VN
  INInwardFromINAdjustmentDetailCustom: 211, // nhập kho từ điều chỉnh tồn kho
  INInwardFromINAdjustmentDetailChangeAmountCustom: 213, // nhập kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)
  INOutwardFromINAdjustmentDetailCustom: 212, // xuất kho từ điều chỉnh tồn kho
  INOutwardFromINAdjustmentDetailRealNameCustom: 214, // xuất kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)
  // Chuyển khoản kho bạc mua vthh
  57: {
    ApproveVoucherPUPaymentTab: 'BUTransferPurchaseDetailCustom',
    ApproveVoucherINInwardTab: 'BUTransferPurchaseIninwardDetailCustom',
    ApproveVoucherBUTransferTab: 'BUTransferPurchaseDetailCustom',
  },
  // Chi mua vật tư hàng hóa
  107: {
    ApproveVoucherPUPaymentTab: 'CAPaymentPurchaseDetailCustom',
    ApproveVoucherCAPayment: 'CAPaymentPurchaseDetailCustom',
    ApproveVoucherINInwardTab: 'CAPaymentPurchaseINInwardDetailCustom',
  },
  // Chi tiền gửi mua vật tư hàng hóa
  158: {
    ApproveVoucherPUPaymentTab: 'BAWithdrawPurchaseDetailCustom',
    ApproveVoucherINInwardTab: 'BAWithdrawPurchaseINinwardDetailCustom',
    ApproveVoucherBAWithDrawTab: 'BAWithdrawPurchaseDetailCustom',
  },
  BUTreasuryFundTransferSalaryDetailCustom: 564, //Chuyển khoản lương
  BUTreasuryFundTransferInsurancePaymentDetailCustom: 565, // Chuyển khoản thanh toán bảo hiểm
  //ckkb trả ncc
  59: {
    ApproveVoucherPUVendorPaymentTab: 'BUTransferVendorPaymentDetailCustom',
    ApproveVoucherBUTransferTab: 'BUTransferVendorPaymentDetailCustom',
  },
  CAPaymentVendorDetailCustom: 109, // Chi trả nhà cung cấp
  // Chi tiền gửi trả nhà cung cấp
  160: {
    ApproveVoucherPUVendorPaymentTab: 'BAWithdrawVendorDetailCustom',
    ApproveVoucherBAWithDrawTab: 'BAWithdrawVendorDetailCustom',
  },
  SASaleInvoiceDetailCustom: [701,708], //Hóa đơn
  StatisticDayOffDetailCustom: 501, //Tổng hợp ngày nghỉ, làm thêm làm đêm
  PASalaryDetailsCustom: [509, 508], // Bảng truy lĩnh lương
  PAOtherOutcomeDetailCustom: 506, // Khấu trừ không thường xuyên
  PAOtherIncomeDetailCustom: 505, // Thu nhập không thường xuyên
  SalaryDetailsCustom: 502, // bảng lương
  OPBalance: [551, 552, 553, 554, 555, 556, 557, 558, 559, 601, 604, 605], //Số dư ban đầu
  BUTransferSalDetailCustom: 60, //Chuyển khoản kho bạc trả lương
  BAWithDrawSalDetailCustom: 163, //Chi tiền gửi trả lương
  CAPaymentSalDetailCustom: 110, // phiếu chi trả lương
  PAPersonalIncomeTaxDetailCustom: 510, // Bảng tính thuế
  GLPayrollExpenseDetailCustom: 405, //Hạch toán chi phí lương
  FAAdjustmentDetailCustom: 254, // Đánh giá lại TSCĐ
  FAIncrementDetailCustom: 252, // Nhận bằng hiện vật và ghi tăng
  FASaleInvoiceDetailCustom: 256, //Bán TSCĐ chưa thu tiền
  FADecrementDetailCustom: 253, // Ghi giảm TSCĐ
  FAInvoiceFixedAssetDetailCustom: 251, // Mua TSCĐ cố định chưa thanh toán (Hóa đơn mua TSCĐ)
  BUTransferFixedAssetDetailCustom: 58, //Chuyển khoản kho bạc mua tscđ
  CAPaymentFixedAssetDetailCustom: 108, // chi mua tscđ
  BAWithDrawFixedAssetDetailCustom: 159, // chi tiền gửi mua tscđ
  FADepreciationDetailCustom: 255, // Hao mòn TSCĐ
  FADevaluationDetailCustom: 419, // khấu hao TSCĐ
  FATransferDetailCustom: 257, // Điều chuyển tài sản cố định
  CAReceiptFixedAssetDetailCustom: 103, // Phiếu thu bán TSCĐ
  BADepositFixedAssetDetailCustom: 155, //Thu tiền gửi từ Bán tài sản cố định
  TACircularVATDeclarationDetailCustom: 469, // Tờ Khai giá trị gia tăng
  OpeningSupplyEntryDetail: 602, // Nhập công cụ dụng cụ ban đầu
  SAReceptInvoiceDetailCustom: 707, // biên lai
  TAEnterpriseIncomeTaxDetailCustom: 470 // Tờ khai thuế TNDN
};
